<template>
  <HiloModal
    :isVisible="isVisible"
    title="Sign Document"
    :showCloseButton="false"
    :footerButtons="[
      { label: 'Save Signature', type: 'primary', onClick: saveSignature },
      { label: 'Cancel', type: 'secondary', onClick: closeModal }
    ]"
    @close="closeModal"
  >
    <div>
      <h4 style="text-align:center">Select the pre-generated signature or draw your own</h4>
      <div class="pre-generated-signature">
        <canvas ref="signatureCanvas" width="250px" height="18px" class="signature-canvas"></canvas>
        <div class="signature-button-container">
          <hilo-button label="Use this signature" @click="useGeneratedSignature"/>
        </div>
      </div>

      <div class="signature-pad-container">
        <vue-signature-pad ref="signaturePad" height="150px" />
        <hilo-button label="Clear Signature" @click="clearSignature"/>
      </div>
    </div>
  </HiloModal>
</template>

<script>
import HiloModal from './HiloModal.vue';
import HiloButton from './HiloButton.vue';

export default {
  components: {
    HiloButton,
    HiloModal,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.drawSignatureOnCanvas(this.$refs.signatureCanvas, 18);
        });
      }
    }
  },
  methods: {
    drawSignatureOnCanvas(canvas, fontSize) {
      const ctx = canvas.getContext("2d");
      ctx.font = `italic ${fontSize}px Georgia`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillText(`${this.firstName} ${this.lastName}`, canvas.width / 2, canvas.height / 2);
    },
    useGeneratedSignature() {
      const signaturePadCanvas = this.$refs.signaturePad.$el.querySelector('canvas');
      this.drawSignatureOnCanvas(signaturePadCanvas, 60);
      const signatureDataURL = signaturePadCanvas.toDataURL('image/png');
      this.$emit('save', signatureDataURL);
      this.closeModal();
    },
    saveSignature() {
      const signature = this.$refs.signaturePad.saveSignature();

      if (this.$refs.signaturePad.isEmpty()) {
        alert("Please draw your signature before saving.");
        return;
      }

      this.$emit('save', signature.data);
      this.closeModal();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.signature-pad-container {
  border: 1px solid #333;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
}

.pre-generated-signature {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.signature-canvas {
  border: 1px solid black;
  border-radius: 8px;
  margin-right: 20px;
}

.signature-button-container {
  display: flex;
  align-items: center;
}

canvas {
  display: block;
  padding: 5px;
}
</style>
